<template>
  <div class="pageContent">
    <div class="content">
      <div class="options">
        <el-form size="small">
          <el-form-item label="手机号" class="option_item" label-width="60px">
            <el-input clearable style="width:160px" v-model="mobile"></el-input>
          </el-form-item>
          <el-form-item class="option_item" label="变动类型" label-width="70px">
            <el-select style="width:100px" v-model="type">
              <el-option label="全部" value="0"></el-option>
              <el-option label="增加" value="1"></el-option>
              <el-option label="减少" value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="option_item" label="时间" label-width="45px">
            <el-date-picker
              v-model="timeValue"
              type="datetimerange"
              range-separator="至"
              style="width: 360px"
              value-format="yyyy-MM-dd HH:mm:ss"
              start-placeholder="开始日期"
              end-placeholder="结束日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item class="option_item" label="操作员手机" label-width="90px">
            <el-input clearable style="width:160px" v-model="empMobile"></el-input>
          </el-form-item>
          <el-form-item class="option_item">
            <el-button type="primary" icon="el-icon-search" @click="getData(1)">搜索</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="table_box">
        <el-table :data="tableData" border>
          <el-table-column label="用户名" prop="user.real_name"></el-table-column>
          <el-table-column label="手机号" prop="user.mobile"></el-table-column>
          <el-table-column label="变动金额" prop="show_amount"></el-table-column>
          <el-table-column label="变动时间" prop="create_time"></el-table-column>
          <el-table-column label="说明" prop="text"></el-table-column>
          <el-table-column label="操作员手机号" prop="operate.mobile"></el-table-column>
        </el-table>
      </div>
      <div class="pagination">
        <el-pagination
          layout="prev, pager, next, total, jumper"
          :current-page="page"
          :total="total"
          :page-size="10"
          @current-change="handleCurrentChange">
        </el-pagination>
        <span style="font-size:14px">共计： 
          <span style="margin-right:15px">增加：{{count.add}}</span>
          <span>减少：{{count.reduce}}</span>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { getBalanceLog } from '@/api/vip';
export default {
  computed: {
    ...mapGetters(["token", "app_id"])
  },
  data(){
    return{
      tableData: [], // 表格数据
      page: 1, // 页码
      total: 0, // 总数
      dateValue: [],
      timeValue: [],
      mobile: "",
      count: {},
      type: "0",
      empMobile: ""
    }
  },
  mounted(){
    this.getData();
  },
  methods:{
    getData(i){
      this.page = i || this.page;
      var data = {
        token: this.token,
        app_id: this.app_id,
        page: this.page,
        style: 3
      }
      if(this.timeValue){
        data.start_time = this.timeValue[0]
        data.end_time = this.timeValue[1]
      }
      if(this.mobile != ""){
        data.mobile = this.mobile
      }
      if(this.type != "0"){
        data.type = this.type
      }
      if(this.empMobile != ""){
        data.operate = this.empMobile;
      }
      console.log(data)
      // return false;
      getBalanceLog(data).then(res => {
        if(res.code == 200){
          this.total = res.total;
          this.count = res.count;
          this.tableData = res.data;
          this.tableData.forEach(item => {
            item.show_amount = item.type == 1? "+"+item.amount: item.type == 2? "-"+item.amount:item.amount;
          })
        }else{
          this.tableData = [];
          this.total = 0;
          this.$message(res.msg)
        }
      })
    },
    handleCurrentChange(val){
      this.page = val;
      this.getData();
    }
  },
}
</script>

<style lang="scss" scoped>
.pageContent{
  padding: 10px 15px;
  height: 100%;
  background: #f1f2f6;
  overflow: auto;
  .content{
    background: #fff;
    padding: 15px;
    // display: flex;
    // flex-direction: column;
    .options{
      .option_item{
        display: inline-block;
        margin-right: 15px;
      }
      // .options_input{
      //   width: 230px;
      // }
      .input_box_small{
        width: 240px;
      }
      .date_picker_box{
        width: 140px;
      }
      .time_picker_box{
        width: 125px;
        margin-right: 8px;
      }
      .inline_title{
        margin-left:24px;
        margin-right: 12px;
      }
      .emp_search{
        margin-left:15px;
      }
    }
    .table_box{
      // flex: 1;
      margin-top: 10px;
      margin-bottom: 10px;
    }
    .page{
      margin-top: 15px;
    }
  }
}
</style>